import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Update Layout',
  share: {
    namespace: 'layouts',
    merge: (previous, next) => ({ ...previous, ...next }),
  },
  make: () => ({
    request: (data: any[]) => async ({ http }) => {
      for (let i = 0; i < data.length; i++) {
        await http({
          method: 'PUT',
          route: '/layouts',
          data: data[i],
        });
      }
    },
  }),
});
